import axios from 'axios';
import React, { useEffect, useState } from 'react';
// import { toast, ToastContainer } from 'react-toastify';

function Products() {

    const [product, setProduct] = useState({ id: '', name: "", price: 0, gstpercent: 0 });
    const [data, setData] = useState([]);
    const [id, setId] = useState("");

    function handleChange(event) {
        event.preventDefault();

        // const value = event.target.value;
        // const numValue = parseFloat(value);
        setProduct({ ...product, [event.target.id]: event.target.value });
    }

    useEffect(() => {
        loadData();
    }, []);

    function deleteData(e, id) {
        e.preventDefault();
        // alert(id);

        axios.delete("https://653cb488d5d6790f5ec82dfd.mockapi.io/api/v1/products/" + id)
            .then((res) => {
                // console.log(res.data);
                loadData();
            })
    }

    function updateData(e, id) {
        e.preventDefault();
        setId(id)
        // alert(id);
        axios.get(`https://653cb488d5d6790f5ec82dfd.mockapi.io/api/v1/products/${id}`)
            .then((res) => {
                // console.log(res.data);

                setProduct({
                    name: res.data.name,
                    price: res.data.price,
                    gstpercent: res.data.gstpercent
                });


            })
    }

    function loadData() {
        setProduct({
            name: "",
            price: 0,
            gstpercent: 0

        });
        axios.get("https://653cb488d5d6790f5ec82dfd.mockapi.io/api/v1/products/")
            .then((res) => {
                // console.log( `GET call res.data: ${res.data}`);
                setData(res.data)

            })
        // console.log(data);
    }

    const save = (e) => {
        e.preventDefault();


        if (id !== undefined) {
            axios.put(`https://653cb488d5d6790f5ec82dfd.mockapi.io/api/v1/products/${id}`, product)
                .then((res) => {
                    // console.log(res.data);
                    loadData();
                    setId(undefined)
                })
        } else {
            axios.post(`https://653cb488d5d6790f5ec82dfd.mockapi.io/api/v1/products/`, product)
                .then((res) => {
                    // console.log(`Post data: ${res.data}`);
                    loadData();
                })
        }
        // if (product.name === "") {
        //     toast.error("Please enter name");
        //     return;
        // }
        // else if (product.price === 0) {
        //     toast.error("Please enter price");
        //     return;
        // } else if (product.gstpercent < 0 || product.gstpercent > 100) {
        //     toast.error("Please enter valid GST percent");
        //     return;
        // }

        // console.log(product);

    }

    return (
        <div className=' '>

            <main id="main" className="main">
                {/* <ToastContainer /> */}
                <div className="pagetitle d-flex justify-content-between align-items-center">
                    <div>
                        <h1>Products</h1>
                    </div>

                    <button data-bs-toggle='modal' data-bs-target='#demo' type="edit" className="btn btn-primary">Add</button>
                </div>
                <div className="card">
                    <div className="card-body ">

                        <table className="table table-striped">
                            <thead>
                                <tr>
                                    <th scope="col">Action</th>
                                    <th scope="col">No</th>
                                    <th scope="col">Name</th>
                                    <th scope="col">Price</th>
                                    <th scope="col">GST %</th>

                                </tr>
                            </thead>
                            <tbody>
                                {
                                    data.map((item, i) => {

                                        const price = parseInt(item.price);
                                        const gstpercent = parseInt(item.gstpercent);
                                        return (
                                            <tr key={i}>
                                                <th>
                                                    <div className='d-flex justify-content-start align-items-center gap-2'>
                                                        <button onClick={(e) => { updateData(e, item.id) }} className='btn btn-secondary btn-sm'>Edit</button>
                                                        <button onClick={(e) => { deleteData(e, item.id) }} className='btn btn-danger btn-sm'>Delete</button>
                                                    </div>
                                                </th>
                                                <th scope="row">{i + 1}</th>
                                                <td className=''>{item.name}</td>
                                                <td className=''>{price.toFixed(2)}</td>
                                                {/* <td className='text-end'>{item.price.padEnd(3, '00')}</td> */}
                                                <td className=''>{gstpercent.toFixed(2)}</td>
                                                {/* <td>{item.id}</td> */}
                                            </tr>
                                        )
                                    })
                                }

                            </tbody>
                        </table>
                    </div>
                </div>
                <div id='demo' className='modal'>
                    <div className='modal-dialog modal-dialog-centered modal-lg'>
                        <div className='modal-content'>
                            <div className='modal-header'>
                                <h3 className=''>Add Product</h3>
                                <button type='button' className='btn-close ' data-bs-dismiss='modal'></button>
                            </div>
                            <div className='modal-body'>
                                <div className="card container col-lg-12 ">
                                    <div className="card-body">
                                        <div className="row g-3">
                                            <div className="col-12">
                                                <label className="form-label">Name</label>
                                                <input type="text " className="form-control" id="name" value={product.name} onChange={(e) => { handleChange(e) }} />
                                            </div>
                                            <div className="col-12">
                                                <label className="form-label">Price</label>
                                                <input type="number " className="form-control" id="price" value={product.price} onChange={(e) => { handleChange(e) }} />
                                            </div>
                                            <div className="col-12">
                                                <label className="form-label">GST %</label>
                                                <input type="number " className="form-control" id="gstpercent" value={product.gstpercent} onChange={(e) => { handleChange(e) }} />
                                            </div>


                                        </div>

                                    </div>
                                </div>

                            </div>
                            <div className='modal-footer'>

                                <div className="text-center center">
                                    <button type="submit" className="btn btn-primary" onClick={(e) => { save(e) }}>Save</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

            </main>
        </div>
    )
}

export default Products